import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

interface TranslationTag {
  tag: string;
  text: string;
}

interface TranslationCategory {
  categoryName: string;
  tags: TranslationTag[];
}

interface TranslationApiResponse {
  data: {
    categories: TranslationCategory[];
  };
  errors: any[];
}

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private translations: Record<string, string> = {};

  constructor(private http: HttpClient) {}

  loadTranslations(lang: string): Observable<Record<string, string>> {
    return this.http.get<TranslationApiResponse>(
      `/slt/translation/api/secure/jas/user/get-i18n/${lang}`
    ).pipe(
      map((response) => {
        const flatTranslations: Record<string, string> = {};

        const categories = response?.data?.categories;
        if (!Array.isArray(categories)) {
          console.warn('Translation API returned an unexpected structure:', response);
          return flatTranslations;
        }

        for (const category of categories) {
          const categoryPrefix = category.categoryName;
          for (const tag of category.tags || []) {
            if (tag && typeof tag.tag === 'string' && typeof tag.text === 'string') {
              const key = `${categoryPrefix}.${tag.tag}`;
              flatTranslations[key] = tag.text;
            } else {
              console.warn(`Invalid tag found in category "${categoryPrefix}":`, tag);
            }
          }
        }

        this.translations = flatTranslations;
        return flatTranslations;
      })
    );
  }

  translate(key: string, params?: Record<string, string>): string {
    let text = this.translations[key] || key;

    if (params) {
      for (const [paramKey, paramValue] of Object.entries(params)) {
        const pattern = new RegExp(`{{\\s*${paramKey}\\s*}}`, 'g');
        text = text.replace(pattern, paramValue);
      }
    }

    return text;
  }

  getAllTranslations(): Record<string, string> {
    return this.translations;
  }
}
